export function hasQueryParams(url: string) {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return Array.from(parsedUrl.searchParams).length > 0;
    } catch {
        return false;
    }
}
